import React, { useEffect, useState } from 'react';
import Icon from '../components/ui/Icon';
import './TestWaitingPage.css';

const TestWaitingPage = ({ testName, testDuration, testMarks, scheduledTime, onTimeReached }) => {
  const [countdown, setCountdown] = useState('');
  const [timeStatus, setTimeStatus] = useState('waiting'); // 'waiting', 'starting', 'closed'

  useEffect(() => {
    const updateCountdown = () => {
      const now = new Date().getTime();
      const scheduled = new Date(scheduledTime).getTime();
      const startTime = scheduled + (5 * 60 * 1000); // scheduled_time + 5 minutes
      const diff = startTime - now;

      if (diff <= 0) {
        setTimeStatus('starting');
        if (onTimeReached) onTimeReached();
      } else {
        const mins = Math.floor(diff / 60000);
        const secs = Math.floor((diff % 60000) / 1000);
        setCountdown(`${mins}:${secs < 10 ? '0' : ''}${secs}`);
        setTimeStatus('waiting');
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, [scheduledTime, onTimeReached]);

  const startDate = new Date(scheduledTime);
  startDate.setMinutes(startDate.getMinutes() + 5);

  return (
    <div className="tw-screen">
      <div className="tw-card">
        <div className="tw-icon"><Icon name="timer" size={56} /></div>

        <h1 className="tw-title">Your test will start soon</h1>
        <p className="tw-test-name">{testName}</p>

        <div className="tw-details">
          <div className="tw-detail">
            <span className="tw-detail-label">Duration</span>
            <span className="tw-detail-value">{testDuration} mins</span>
          </div>
          <div className="tw-detail">
            <span className="tw-detail-label">Total Marks</span>
            <span className="tw-detail-value">{testMarks}</span>
          </div>
        </div>

        <div className="tw-time-block">
          <p className="tw-time-label">Test will start at:</p>
          <p className="tw-time">
            {startDate.toLocaleTimeString('en-IN', {
              hour: '2-digit', minute: '2-digit', second: '2-digit',
              hour12: true
            })}
          </p>
          <p className="tw-date">
            {startDate.toLocaleDateString('en-IN', {
              day: '2-digit', month: 'short', year: 'numeric'
            })}
          </p>
        </div>

        {timeStatus === 'waiting' && (
          <div className="tw-countdown" role="timer" aria-live="off">
            <p className="tw-countdown-label">Starts in</p>
            <p className="tw-countdown-timer">{countdown}</p>
          </div>
        )}

        {timeStatus === 'starting' && (
          <div className="tw-starting" role="status">
            <p className="tw-starting-text"><Icon name="bolt" size={20} /> Test is starting…</p>
          </div>
        )}

        <div className="tw-info">
          <Icon name="info" size={18} />
          <div>
            <p>Please wait. The test will start automatically when the time arrives.</p>
            <p>Do not close this page.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestWaitingPage;
